import { render, staticRenderFns } from "./OrderNew.vue?vue&type=template&id=f33f5164&scoped=true"
import script from "./OrderNew.vue?vue&type=script&lang=js"
export * from "./OrderNew.vue?vue&type=script&lang=js"
import style0 from "./OrderNew.vue?vue&type=style&index=0&id=f33f5164&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f33f5164",
  null
  
)

export default component.exports